module.exports = __webpack_public_path__ + "static/img/SG@2x.13325c99.jpg";